import React from "react";
import Input from "../Input/Input";
import "./Form.scss";
import axios from "axios";
import { ReactSketchCanvas } from "react-sketch-canvas";
import judete from "../assets/judete.json";
import arrow_down from "../assets/arrow_down_white.png";
import arrow_down_grey from "../assets/arrow_down_grey.png";
import Loader from "react-loader-spinner";
import { baseUrl, prepareForComparation } from "../utils/function";


const signatureWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABSYAAAEsCAYAAADehm0+AAAAAXNSR0IArs4c6QAAHZJJREFUeF7t2MEJADAMA7F2/6Fd6BD3UhYwiLzubttxBAgQIECAAAECBAgQIECAAAECBAgQCAWuMBlqmyJAgAABAgQIECBAgAABAgQIECBA4AsIkx6BAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQICBM+gECBAgQIECAAAECBAgQIECAAAECBHIBYTInN0iAAAECBAgQIECAAAECBAgQIECAgDDpBwgQIECAAAECBAgQIECAAAECBAgQyAWEyZzcIAECBAgQIECAAAECBAgQIECAAAECwqQfIECAAAECBAgQIECAAAECBAgQIEAgFxAmc3KDBAgQIECAAAECBAgQIECAAAECBAgIk36AAAECBAgQIECAAAECBAgQIECAAIFcQJjMyQ0SIECAAAECBAgQIECAAAECBAgQIPAAD26suR+XQG4AAAAASUVORK5CYII=';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      last_name: "",
      fathers_initial: "",
      first_name: "",
      street: "",
      street_number: "",
      address_building: "",
      address_staircase: "",
      address_floor: "",
      address_apartment: "",
      county: "",
      city: "",
      postal_code: "",
      personal_id: "",
      email_address: "",
      phone_number: "",
      signature_url: "",
      error: "",
      isLoading: false,
      buttonClicked: false,
      years: "2",

      county_dropdown_opened: false,
      city_dropdown_opened: false,
    };
    this.canvas = React.createRef();

    this.setCountyRef = this.setCountyRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.setCityRef = this.setCityRef.bind(this);
    this.handleClickOutsideCity = this.handleClickOutsideCity.bind(this);
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  submitForm = () => {
    const payload = {
      id_club: this.props.id_club,
      last_name: this.state.last_name,
      fathers_initial: this.state.fathers_initial,
      first_name: this.state.first_name,
      street: this.state.street,
      street_number: this.state.street_number,
      address_building: this.state.address_building,
      address_staircase: this.state.address_staircase,
      address_floor: this.state.address_floor,
      address_apartment: this.state.address_apartment,
      county: this.state.county,
      city: this.state.city,
      postal_code: this.state.postal_code,
      personal_id: this.state.personal_id,
      email_address: this.state.email_address,
      phone_number: this.state.phone_number,
      img_base64: this.state.signature_url,
      no_of_years: this.state.years,
    };
    if (this.validateForm()) {
      this.setState({ isLoading: true, buttonClicked: true });
      axios
        .post(
          baseUrl("club/submit_tax_redirector"),
          payload
        )
        .then((res) => {
          this.setState({ isLoading: false }, this.clearFields);
          this.props.history.push({
            pathname: "/success",
            state: {
              download_id: res?.data?.inserted_id,
              unique_form_id: res?.data?.unique_form_id
            },
          });
        })
        .catch((err) => console.log(err));
    } else {
      this.setState({ error: "Toate campurile sunt obligatorii!" });
    }
  };

  validateForm = () => {
    return (
      this.state.last_name !== "" &&
      this.state.fathers_initial !== "" &&
      this.state.first_name !== "" &&
      this.state.street !== "" &&
      this.state.street_number !== "" &&
      this.state.address_building !== "" &&
      this.state.address_staircase !== "" &&
      this.state.address_floor !== "" &&
      this.state.address_apartment !== "" &&
      this.state.county !== "" &&
      this.state.city !== "" &&
      this.state.postal_code !== "" &&
      this.state.personal_id !== "" &&
      this.state.email_address !== "" &&
      this.state.phone_number !== "" &&
      this.state.signature_url !== ""
    );
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);

    let updateState = {};

    const countyToSearch = params.get('county') ?? "";
    const countySearchResult = judete.judete.find(e => prepareForComparation(e.nume) === prepareForComparation(countyToSearch));
    if (countySearchResult) {
      updateState = { ...updateState, county: countySearchResult.nume };
      const cityToSearch = params.get('city') ?? "";
      const citySearchResult = (countySearchResult?.localitati ?? []).find(e => prepareForComparation(e.nume) === prepareForComparation(cityToSearch));
      if (citySearchResult) {
        updateState = { ...updateState, city: citySearchResult.nume };
      }
    }

    updateState = {
      ...updateState,
      last_name: params.get('name') ?? "",
      first_name: params.get('surname') ?? "",
      street: params.get('street') ?? "",
      street_number: params.get('nr_street') ?? "",
      address_apartment: params.get('nr_apartment') ?? "",
      personal_id: params.get('cnp_parent') ?? "",
      email_address: params.get('email') ?? "",
      phone_number: params.get('phone_number') ?? "",
    };

    this.setState({ ...this.state, ...updateState });
    window.history.replaceState(null, null, window.location.origin + window.location.pathname)

    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("mousedown", this.handleClickOutsideCity);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener("mousedown", this.handleClickOutsideCity);
  }

  /**
   * Set the wrapper ref
   */
  setCountyRef(node) {
    this.countyRef = node;
  }

  setCityRef(node) {
    this.cityRef = node;
  }

  handleClickOutside = (event) => {
    if (this.countyRef && !this.countyRef.contains(event.target)) {
      this.setState({ county_dropdown_opened: false });
    }
  };

  handleClickOutsideCity = (event) => {
    if (this.cityRef && !this.cityRef.contains(event.target)) {
      this.setState({ city_dropdown_opened: false });
    }
  };

  clearFields = () => {
    this.setState({
      last_name: "",
      fathers_initial: "",
      first_name: "",
      street: "",
      street_number: "",
      address_building: "",
      address_staircase: "",
      address_floor: "",
      address_apartment: "",
      county: "",
      city: "",
      postal_code: "",
      personal_id: "",
      email_address: "",
      phone_number: "",
      signature_url: "",
      error: "",
    });
  };

  citiesList = () => {
    if (this.state.county !== "") {
      return judete.judete.filter((item) => item.nume === this.state.county)[0]
        .localitati;
    } else return [];
  };

  handleRadioButtons = (e) => {
    this.setState({
      years: e.target.value
    })
  }

  render() {
    return (
      <>
        {this.props.width > 1200 ? (
          <div className="form-container">
            <div className="form-header">
              <div className="logo">
                <img
                  src={baseUrl(`uploads/club_logos/${this.props.id_club}.png`)}
                  alt=""
                />
              </div>
              <div className="description_form" style={{ color: this.props.title_color }}>
                {this.props.declaration_form_description}
              </div>
              <div className="title" style={{ color: this.props.title_color }}>
                Formular redirectionare impozit
              </div>
            </div>
            <div className="row">
              <Input
                name="last_name"
                label="Nume"
                value={this.state.last_name}
                handleChange={this.handleChange}
                className="name-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />

              <Input
                name="first_name"
                label="Prenume"
                value={this.state.first_name}
                handleChange={this.handleChange}
                className="name-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="fathers_initial"
                label="Initiala tatalui"
                value={this.state.fathers_initial}
                handleChange={this.handleChange}
                className="initial-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div className="row">
              <Input
                name="street"
                label="Strada"
                value={this.state.street}
                handleChange={this.handleChange}
                className="street-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="street_number"
                label="Numar"
                value={this.state.street_number}
                handleChange={this.handleChange}
                className="address-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="address_building"
                label="Bloc"
                value={this.state.address_building}
                handleChange={this.handleChange}
                className="address-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="address_staircase"
                label="Scara"
                value={this.state.address_staircase}
                handleChange={this.handleChange}
                className="address-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="address_floor"
                label="Etaj"
                value={this.state.address_floor}
                handleChange={this.handleChange}
                className="address-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="address_apartment"
                label="Apartament"
                value={this.state.address_apartment}
                handleChange={this.handleChange}
                className="address-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div className="row">
              <Input
                name="postal_code"
                label="Cod postal"
                value={this.state.postal_code}
                handleChange={this.handleChange}
                className="city-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />

              <div className="custom-dropdown-container">
                {!this.state.county_dropdown_opened ? (
                  <div
                    className="custom-dropdown-closed"
                    style={{ color: this.props.title_color }}
                    onClick={() =>
                      this.setState({ county_dropdown_opened: true })
                    }
                  >
                    <div>
                      {this.state.county.length ? this.state.county : "Judet"}
                    </div>
                    <img src={arrow_down_grey} alt="arrow" />
                  </div>
                ) : (
                  <div
                    className="custom-dropdown-opened"
                    ref={this.setCountyRef}
                    style={{
                      backgroundColor: this.props.color,
                      color: this.props.second_color,
                    }}
                  >
                    {judete.judete.map((item, index) => {
                      return (
                        <div
                          key={item.nume}
                          className="custom-dropdown-item"
                          onClick={() =>
                            this.setState({
                              county: item.nume,
                              county_dropdown_opened: false,
                            })
                          }
                        >
                          {item.nume}
                          {index === 0 && <img src={arrow_down} alt="arrow" />}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="custom-dropdown-container">
                {this.state.city_dropdown_opened && this.state.county !== "" ? (
                  <div
                    className="custom-dropdown-opened"
                    ref={this.setCityRef}
                    style={{
                      backgroundColor: this.props.color,
                      color: this.props.second_color,
                    }}
                  >
                    {this.citiesList().map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="custom-dropdown-item"
                          onClick={() =>
                            this.setState({
                              city: item.nume,
                              city_dropdown_opened: false,
                            })
                          }
                        >
                          {item.nume}
                          {index === 0 && <img src={arrow_down} alt="arrow" />}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    className="custom-dropdown-closed"
                    style={{ color: this.props.title_color }}
                    onClick={() =>
                      this.setState({ city_dropdown_opened: true })
                    }
                  >
                    <div>
                      {this.state.city.length ? this.state.city : "Localitate"}
                    </div>
                    <img src={arrow_down_grey} alt="arrow" />
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <Input
                name="personal_id"
                label="Cod numeric personal (CNP)"
                value={this.state.personal_id}
                handleChange={this.handleChange}
                className="city-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="email_address"
                label="Email"
                value={this.state.email_address}
                handleChange={this.handleChange}
                className="city-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="phone_number"
                label="Numar de telefon"
                value={this.state.phone_number}
                handleChange={this.handleChange}
                className="city-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div className="row years" style={{ color: this.props.title_color }}>
              Perioada
              <form>
                <label className="label-radio">
                  <input type="radio" value="1"
                    checked={this.state.years === '1'}
                    onChange={this.handleRadioButtons}
                  />
                  1 an
                </label>
                <label className="label-radio">
                  <input type="radio" value="2"
                    checked={this.state.years === '2'}
                    onChange={this.handleRadioButtons}
                  />
                  2 ani
                </label>
              </form>
            </div>
            {this.state.signature_url === "" ? (
              <div className="signature-container">
                <div
                  className="signature-label"
                  style={{ color: this.props.title_color }}
                >
                  Semneaza aici:
                </div>
                <ReactSketchCanvas
                  ref={this.canvas}
                  strokeWidth={5}
                  strokeColor="black"
                  height={300}
                />
                <div className="signature-buttons">
                  <button
                    className="submit-button cancel-button"
                    style={{ color: this.props.title_color }}
                    onClick={() => {
                      this.canvas.current.resetCanvas();
                    }}
                  >
                    STERGE
                  </button>
                  <button
                    className="submit-button"
                    style={{
                      backgroundColor: this.props.color,
                      color: this.props.second_color,
                    }}
                    onClick={() => {
                      this.canvas.current
                        .exportImage("png")
                        .then((data) => {
                          if (signatureWhite != data) {
                            this.setState({ signature_url: data });
                          }
                        })
                        .catch((e) => {
                          console.log(e);
                        });
                    }}
                  >
                    SALVEAZA
                  </button>
                </div>
              </div>
            ) : (
              <div className="finished-signature-container">
                <img src={this.state.signature_url} alt="signature" />
              </div>
            )}
            <div className="error-row">{this.state.error}</div>
            <div className="row submit-button-row">
              <button
                className="submit-button final-submit-button"
                style={{
                  backgroundColor: this.props.color,
                  color: this.props.second_color,
                }}
                onClick={this.state.buttonClicked ? () => { } : this.submitForm}
              >
                {this.state.isLoading ? (
                  <Loader
                    type="TailSpin"
                    color="#FFFFFF"
                    height={40}
                    width={40}
                  />
                ) : (
                  "TRIMITE FORMULAR"
                )}
              </button>
            </div>
            <div className="footer">
              <a
                href="https://www.tfb.ai/ro"
                target="_blank"
                style={{
                  color: this.props.second_color == "#ffffff" ? this.props.color : this.props.second_color,
                  textDecoration: "inherit",
                }}
              >
                <div>Powered by The Football Brain</div>
              </a>
              <a
                href='/api/v1/print/example.pdf'
                style={{
                  color: this.props.second_color == "#ffffff" ? this.props.color : this.props.second_color,
                  textDecoration: "inherit",
                }}
                target='_blank'
                rel='noopener noreferrer'>
                GDPR
              </a>
            </div>
          </div>
        ) : (
          <div className="form-container-mobile">
            <div className="form-header">
              <div className="logo">
                <img
                  src={baseUrl(`uploads/club_logos/${this.props.id_club}.png`)}
                  alt=""
                />
              </div>
              <div className="description_form" style={{ color: this.props.title_color }}>
                {this.props.declaration_form_description}
              </div>
              <div className="title" style={{ color: this.props.title_color }}>
                Formular redirectionare impozit
              </div>
            </div>
            <div className="row">
              <Input
                name="last_name"
                label="Nume"
                value={this.state.last_name}
                handleChange={this.handleChange}
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div className="row">
              <Input
                name="first_name"
                label="Prenume"
                value={this.state.first_name}
                handleChange={this.handleChange}
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div className="row">
              <Input
                name="fathers_initial"
                label="Initiala tatalui"
                value={this.state.fathers_initial}
                handleChange={this.handleChange}
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div
              className="row"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Input
                name="street"
                label="Strada"
                value={this.state.street}
                handleChange={this.handleChange}
                className="street-name-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="street_number"
                label="Numar"
                value={this.state.street_number}
                handleChange={this.handleChange}
                className="street-number-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div
              className="row"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Input
                name="address_building"
                label="Bloc"
                value={this.state.address_building}
                handleChange={this.handleChange}
                className="address-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="address_staircase"
                label="Scara"
                value={this.state.address_staircase}
                handleChange={this.handleChange}
                className="address-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="address_floor"
                label="Etaj"
                value={this.state.address_floor}
                handleChange={this.handleChange}
                className="address-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
              <Input
                name="address_apartment"
                label={window.innerWidth > 1200 ? "Apartament" : "Apt."}
                value={this.state.address_apartment}
                handleChange={this.handleChange}
                className="address-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <Input
                name="postal_code"
                label="Cod postal"
                value={this.state.postal_code}
                handleChange={this.handleChange}
                className="city-input"
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />

              <div className="custom-dropdown-container city-input">
                {!this.state.county_dropdown_opened ? (
                  <div
                    className="custom-dropdown-closed"
                    onClick={() =>
                      this.setState({ county_dropdown_opened: true })
                    }
                    style={{ color: this.props.title_color }}
                  >
                    <div>
                      {this.state.county.length ? this.state.county : "Judet"}
                    </div>
                    <img src={arrow_down_grey} alt="arrow" />
                  </div>
                ) : (
                  <div
                    className="custom-dropdown-opened"
                    ref={this.setCountyRef}
                    style={{ backgroundColor: this.props.color }}
                  >
                    {judete.judete.map((item, index) => {
                      return (
                        <div
                          key={item.nume}
                          className="custom-dropdown-item"
                          onClick={() =>
                            this.setState({
                              county: item.nume,
                              county_dropdown_opened: false,
                            })
                          }
                        >
                          {item.nume}
                          {index === 0 && <img src={arrow_down} alt="arrow" />}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div
                className="custom-dropdown-container"
                style={{ width: "100%" }}
              >
                {this.state.city_dropdown_opened && this.state.county !== "" ? (
                  <div
                    className="custom-dropdown-opened"
                    ref={this.setCityRef}
                    style={{ backgroundColor: this.props.color }}
                  >
                    {this.citiesList().map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="custom-dropdown-item"
                          onClick={() =>
                            this.setState({
                              city: item.nume,
                              city_dropdown_opened: false,
                            })
                          }
                        >
                          {item.nume}
                          {index === 0 && <img src={arrow_down} alt="arrow" />}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    className="custom-dropdown-closed"
                    onClick={() =>
                      this.setState({ city_dropdown_opened: true })
                    }
                    style={{ color: this.props.title_color }}
                  >
                    <div>
                      {this.state.city.length ? this.state.city : "Localitate"}
                    </div>
                    <img src={arrow_down_grey} alt="arrow" />
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <Input
                name="personal_id"
                label="Cod numeric personal (CNP)"
                value={this.state.personal_id}
                handleChange={this.handleChange}
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div className="row">
              <Input
                name="email_address"
                label="E-mail"
                value={this.state.email_address}
                handleChange={this.handleChange}
                labelColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div className="row">
              <Input
                name="phone_number"
                label="Numar de telefon"
                value={this.state.phone_number}
                handleChange={this.handleChange}
                labelColor={this.props.title_color}
                textColor={this.props.title_color}
                id_club={this.props.id_club}
                main_color={this.props.color}
              />
            </div>
            <div className="row years" style={{ color: this.props.title_color }}>
              Perioada
              <form>
                <label>
                  <input type="radio" value="1"
                    checked={this.state.years === '1'}
                    onChange={this.handleRadioButtons}
                  />
                  1 an
                </label>
                <label>
                  <input type="radio" value="2"
                    checked={this.state.years === '2'}
                    onChange={this.handleRadioButtons}
                  />
                  2 ani
                </label>
              </form>
            </div>
            {this.state.signature_url === "" ? (
              <div className="signature-container">
                <div
                  className="signature-label"
                  style={{ color: this.props.title_color }}
                >
                  Semneaza aici:
                </div>
                <ReactSketchCanvas
                  ref={this.canvas}
                  strokeWidth={5}
                  strokeColor="black"
                  height={300}
                />
                <div className="signature-buttons">
                  <button
                    className="submit-button cancel-button"
                    style={{ color: this.props.title_color }}
                    onClick={() => {
                      this.canvas.current.resetCanvas();
                    }}
                  >
                    STERGE
                  </button>
                  <button
                    className="submit-button"
                    style={{
                      backgroundColor: this.props.color,
                      color: this.props.second_color,
                    }}
                    onClick={() => {
                      this.canvas.current
                        .exportImage("png")
                        .then((data) => {
                          this.setState({ signature_url: data });
                        })
                        .catch((e) => {
                          console.log(e);
                        });
                    }}
                  >
                    SALVEAZA
                  </button>
                </div>
              </div>
            ) : (
              <div className="finished-signature-container">
                <img src={this.state.signature_url} alt="signature" />
              </div>
            )}
            <div className="error-row">{this.state.error}</div>
            <div className="row submit-button-row">
              <button
                className="submit-button final-submit-button"
                onClick={this.state.buttonClicked ? () => { } : this.submitForm}
                style={{
                  backgroundColor: this.props.color,
                  color: this.props.second_color,
                }}
              >
                {this.state.isLoading ? (
                  <Loader
                    type="TailSpin"
                    color="#FFFFFF"
                    height={25}
                    width={25}
                  />
                ) : (
                  "TRIMITE FORMULAR"
                )}
              </button>
            </div>
            <div className="footer">
              <a
                href="https://www.tfb.ai/ro"
                target="_blank"
                style={{
                  color: this.props.second_color == "#ffffff" ? this.props.color : this.props.second_color,
                  textDecoration: "inherit",
                }}
              >
                <div>Powered by The Football Brain</div>
              </a>
              <a
                href='https://tfb.ai/gdpr.pdf'
                style={{
                  color: this.props.second_color == "#ffffff" ? this.props.color : this.props.second_color,
                  textDecoration: "inherit",
                }}
                target='_blank'
                rel='noopener noreferrer'>
                GDPR
              </a>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default Form;
